<template>
    <ul
        class="c-link-list"
        v-view.once
    >
        <li
            v-for="item in list"
            class="c-link-list__item"
        >
            <h3
                v-if="item.headline"
                class="c-link-list__title | t-t3"
            >
                <a
                    v-if="item.link"
                    :href="item.link"
                    :title="item.label"
                    class="c-link-list__link"
                    target="_blank"
                    rel="noopener"
                    download
                >
                    {{ item.label }}
                    <Icon
                        class="c-link-list__icon"
                        icon="download"
                    ></Icon>
                </a>
                <span
                    v-else
                >
                    {{ item.label }}
                </span>
            </h3>
            <a
                v-else-if="item.link"
                :href="item.link"
                :title="item.label"
                class="c-link-list__link | t-s"
                target="_blank"
                rel="noopener"
                download
            >
                {{ item.label }}
                <Icon
                    class="c-link-list__icon"
                    icon="download"
                ></Icon>
            </a>
            <span
                v-else
            >
                {{ item.label }}
            </span>
        </li>
    </ul>
</template>

<script>
import Icon from 'templates/objects/Icon';

export default {
    name: 'block-link-list',
    components: {
        Icon,
    },
    props: {
        list: {
            type: Array,
        },
    },
};
</script>


<style lang="scss">

    .c-link-list {
        @include reset-list;

        &.view-in {

            .c-link-list__item {
                opacity: 1;
                transform: translate(0) scale(1);

                @for $i from 1 to 20 {

                    &:nth-child(#{$i}) {
                        $i: $i - 1;
                        transition: opacity .4s $out-sine #{$i/15}s, transform .4s $out-expo #{$i/15}s;
                    }
                }
            }
        }
    }

    .c-link-list__item {
        opacity: 0;
        transform: translate(0, 1em) scale(1, .9);
        transform-origin: 50% 100%;

        &:not(:first-child) {
            margin-top: .5em;

            .c-link-list__title {
                margin-top: 1.5em;
            }
        }
    }

    .c-link-list__title {
        margin-bottom: 1.5em;

        @screen sm {
            margin-bottom: 1em;
        }
    }

    .c-link-list__link {
        display: flex;
        width: 100%;
        align-items: flex-start;
        justify-content: space-between;
        user-select: none;

        &:hover {

            .c-link-list__icon {

                &:before {
                    transform: scale(1);
                    transition: transform .4s $out-sine;
                }

                svg {
                    transform: translate(0, -.2rem);
                    transition: transform .4s $out-sine;
                }
            }

        }
    }

    .c-link-list__icon {
        top: .5em;
        flex-shrink: 0;
        width: 2rem;
        margin-left: 1rem;

        &:before {
            @include pseudo-el($width: 2em, $height: .5em)
            position: absolute;
            bottom: calc(-.5em/2);
            left: calc(50% - 2em/2);
            @include linear-gradient(to right, rgba(255, 255, 255, 0), var(--color-main), rgba(255, 255, 255, 0));
            transform: scale(0, 1);
            transition: transform .4s $in-sine;
        }

        svg {
            margin-right: auto;
            margin-left: auto;
            transition: transform .4s $in-sine;
        }
    }

</style>
